export default __webpack_public_path__ + "static/media/moving.472cb0b1.gif";